define('modules/form_editor/views/preview_custom_day',['require','exports','module','./preview_base','ldsh!../templates/preview_custom_range'],function(require, exports, module){
  "use strict";
  var PreviewBase = require("./preview_base");

  module.exports = PreviewBase.extend({
    template: require("ldsh!../templates/preview_custom_range"),
    onRender: function(){
      module.exports.__super__.onRender.apply(this, arguments);
      var start = this.model.get("start") - 1,
          end = this.model.get("end");
      if(this.model.get("firstOptionInvalid")){
        var $firstOption = $("<option />")
          .attr("value", "")
          .text(this.localize("formEditor.selectDay"));

        this.$("select").append($firstOption);
      }
      while (start < end){
        var day = ++start;
        if (this.model.get("fillWithZeroes")) {
          day = ('00' + start).slice(-2);
        }
        this.$("select").append("<option value=" + day + ">" + day + "</option>");
       }
    },
  });
});

